// Angular
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
// Material
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
// Translate
// Module components
import { AuthComponent } from './auth.component';
// Auth
import { SignInComponent } from './signIn/signIn.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { AuthGuard } from 'src/app/Services/auth.guard';
import { AuthNoticeComponent } from './auth-notice/auth-notice.component';
import { LoginComponent } from './login/login.component';
import { SharedDirectiveModule } from 'src/app/sharedDirective/sharedDirective.module';
import { UiSharedModule } from 'src/app/sharedUI/sharedUi.module';

const routes: Routes = [
	{
		path: '',
		component: AuthComponent,
		children: [
			{ path: '', redirectTo: 'login', pathMatch: 'full' },
			// { path: 'signin', component: SignInComponent, data: {returnUrl: window.location.pathname} },
			{ path: 'staff', redirectTo: 'login/staff', pathMatch: 'full' },
			{ path: ':qac/staff', component: SignInComponent },
			// { path: 'login', component: LoginComponent },
			{ path: ':qac', component: SignInComponent },
			// { path: ':qac', component: LoginComponent }, ////       was used to redirect to student login page
			{ path: 'forgetPassword', component: ForgetPasswordComponent, },
			{path: '**', redirectTo: 'login', pathMatch: 'full'}

		]
	}
];


@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MatButtonModule,
		RouterModule.forChild(routes),
		MatInputModule,
		MatFormFieldModule,
		MatCheckboxModule,
		MatSelectModule,
		SharedDirectiveModule,
		UiSharedModule,
	],
	providers: [
	
	],
	exports: [AuthComponent],
	declarations: [
		AuthComponent,
		AuthNoticeComponent,
		SignInComponent,
		ForgetPasswordComponent,
		LoginComponent
	]
})

export class AuthModule {
	static forRoot(): ModuleWithProviders<RouterModule> {
		return {
			ngModule: AuthModule,
			providers: [
				AuthGuard
			]
		};
	}
}
